import WarningNote from './WarningNote';
export default WarningNote;
